import './styles.css';

import { RefObject } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Box } from '@cbhq/cds-web/layout';
import { Avatar } from '@cbhq/cds-web/media/Avatar';
import { Pressable } from '@cbhq/cds-web/system';

import { PACKAGE_VERSION_NAME } from '../../version';
import { useProfileInfo, useProfileMenuV2 } from '../providers/ProfileMenuV2Provider';

const messages = defineMessages({
  profileMenu: {
    defaultMessage: 'Profile menu',
    id: 'ProfileDropdownButton.profileMenu',
    description: 'Accessibility label for the profile menu button.',
  },
});

type ProfileDropdownButtonProps = {
  buttonRef?: RefObject<HTMLButtonElement>;
  onPress?: () => void;
};

export function ProfileDropdownButton({ buttonRef, onPress }: ProfileDropdownButtonProps) {
  const { name = '', avatarUrl } = useProfileInfo();
  const { userSwitcherEnabled, selectedProfile } = useProfileMenuV2();
  const { formatMessage } = useIntl();

  return (
    <Box>
      <Pressable
        background="transparent"
        onClick={onPress}
        accessibilityLabel={formatMessage(messages.profileMenu)}
        borderRadius={1000}
        ref={buttonRef}
        testID="ProfileDropdownButton"
        data-version={PACKAGE_VERSION_NAME}
        className="noBorder"
      >
        <Avatar
          src={userSwitcherEnabled ? selectedProfile?.avatarUrl ?? '' : avatarUrl}
          alt="profile menu"
          name={
            userSwitcherEnabled ? (selectedProfile?.name ?? '').toUpperCase() : name.toUpperCase()
          }
          size="xl"
          colorScheme="teal"
          testID="ProfileDropdownAvatar"
          className="noBorder"
        />
      </Pressable>
    </Box>
  );
}
